/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { reducer as form } from 'redux-form';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react18-router';

// Global Reducers
import languageProviderReducer from 'containers/LanguageProvider/reducer';
import history from '../utils/history';
import authReducer from './modules/authReducer';
import uiReducer from './modules/uiReducer';
import initval from './modules/initFormReducer';
import managerReducer from './modules/backoffice/managerReducer';
import ipReducer from './modules/backoffice/ipReducer';
import myInfoReducer from './modules/setting/myInfoReducer';
import perplayUserReducer from './modules/user/perplayUserReducer';
import campaignReducer from './modules/app/campaignReducer';
import gameReducer from './modules/app/gameReducer';
import logReducer from './modules/backoffice/logReducer';
import walletReducer from './modules/wallet/walletReducer';
import fixAppDataReducer from './modules/app/fixAppDataReducer';
import partnerReducer from './modules/backoffice/partnerReducer';
import postReducer from './modules/user/postReducer';
import maintenanceReducer from './modules/app/maintenanceReducer';
import itemDBReducer from './modules/app/itemDBReducer';
import gameSessionLogReducer from './modules/log/gameSessionLogReducer';
import specialBoxLogReducer from './modules/log/specialBoxLogReducer';
import loginLogReducer from './modules/log/loginLogReducer';
import notificationReducer from './modules/notification/notificationReducer';
import sessionLogReducer from './modules/log/sessionLogReducer';
import miningEventReducer from './modules/event/miningEventReducer';
import freeNFTEventReducer from './modules/event/freeNFTEventReducer';
import invitationReducer from './modules/event/invitationEventReducer';
import starterPackReducer from './modules/event/starterPackEventReducer';
import powerChargeLogReducer from './modules/log/powerChargeLogReducer';
import levelUpLogReducer from './modules/log/levelUpLogReducer';
import breedLogReducer from './modules/log/breedLogReducer';
import evolveLogReducer from './modules/log/evolveLogReducer';
import walletTransactionLogReducer from './modules/log/walletTransactionLogReducer';
import nftTransactionLogReducer from './modules/log/nftTransactionLogReducer';
import inventoryTransactionLogReducer from './modules/log/inventoryTransactionLogReducer';
import systemReducer from './modules/backoffice/systemReducer';
import nftInfoReducer from './modules/monitoring/nftInfoReducer';
import marketTransactionLogReducer from './modules/log/marketTransactionLogReducer';
import holderLogReducer from './modules/log/holderLogReducer';
import nftReducer from './modules/app/nftReducer';
import drawItemEventReducer from './modules/event/drawItemEventReducer';
import gemSocketLogReducer from './modules/log/gemSocketLogReducer';
import resetStatsLogReducer from './modules/log/resetStatsLogReducer';
import statisticsReducer from './modules/monitoring/statisticsReducer';
import nicknameTransactionLogReducer from './modules/log/nicknameTransactionLogReducer';
import gemSocketUpdateLogReducer from './modules/log/gemSocketUpdateLogReducer';
import nftRestoreLogReducer from './modules/log/nftRestoreLogReducer';
import nftRepairLogReducer from './modules/log/nftRepairLogReducer';
import nftRentalLogReducer from './modules/log/nftRentalLogReducer';
import devImageUploadReducer from './modules/app/devImageUploadReducer';
import depositReducer from './modules/wallet/depositReducer';
import nftInventoryValidUpdateReducer from './modules/inventory/nftInventoryValidUpdateReducer';
import walletSettlementReducer from './modules/wallet/settlementReducer';
import gearMiningLogReducer from './modules/log/gearMiningLogReducer';
import nftDisassembleLogReducer from './modules/log/nftDisassembleLogReducer';
import userItemManageReducer from './modules/app/userItemManageReducer';
import inAppIconsReducer from './modules/app/inAppIconsReducer';
import eventPartnerReducer from './modules/event/eventPartnerReducer';
import basicReducer from './modules/app/basicReducer';
import basicMissionLogReducer from './modules/log/basicMissionLogReducer';
import walletConnectionLogReducer from './modules/log/walletConnectionLogReducer';
import inAppRankSystemReducer from './modules/app/inAppRankSystemReducer';
import storedPowerLogReducer from './modules/log/storedPowerLogReducer';
import itemBoxLogReducer from "./modules/log/itemBoxLogReducer";
import googleStorePurchaseLogReducer from "./modules/log/googleStorePurchaseLogReducer";

/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    form,
    ui: uiReducer,
    initval,
    authReducer,
    managerReducer,
    walletReducer,
    logReducer,
    ipReducer,
    myInfoReducer,
    perplayUserReducer,
    gameReducer,
    campaignReducer,
    fixAppDataReducer,
    partnerReducer,
    postReducer,
    maintenanceReducer,
    itemDBReducer,
    gameSessionLogReducer,
    specialBoxLogReducer,
    loginLogReducer,
    notificationReducer,
    sessionLogReducer,
    miningEventReducer,
    freeNFTEventReducer,
    invitationReducer,
    starterPackReducer,
    powerChargeLogReducer,
    levelUpLogReducer,
    breedLogReducer,
    evolveLogReducer,
    walletTransactionLogReducer,
    nftTransactionLogReducer,
    inventoryTransactionLogReducer,
    systemReducer,
    nftInfoReducer,
    statisticsReducer,
    nicknameTransactionLogReducer,
    marketTransactionLogReducer,
    gemSocketLogReducer,
    resetStatsLogReducer,
    gemSocketUpdateLogReducer,
    nftRestoreLogReducer,
    nftRepairLogReducer,
    nftRentalLogReducer,
    gearMiningLogReducer,
    nftDisassembleLogReducer,
    holderLogReducer,
    storedPowerLogReducer,
    nftReducer,
    drawItemEventReducer,
    devImageUploadReducer,
    inAppIconsReducer,
    depositReducer,
    nftInventoryValidUpdateReducer,
    walletSettlementReducer,
    userItemManageReducer,
    eventPartnerReducer,
    missionReducer: basicReducer,
    basicMissionLogReducer,
    walletConnectionLogReducer,
    inAppRankSystemReducer,
    itemBoxLogReducer,
    googleStorePurchaseLogReducer,
    language: languageProviderReducer,
    router: connectRouter(history),
    ...injectedReducers,
  });

  // Wrap the root reducer and return a new root reducer with router state
  const mergeWithRouterState = connectRouter(history);
  return mergeWithRouterState(rootReducer);
}
